import config from '../../config/config';
import DefaultApiLimit from '../../config/defaultLimit';
import { AddFacilityTag } from '../../interface/facility-tag.interface';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Add facility tag API
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  addFacilityTag: (data: AddFacilityTag): Promise<any> => {
    return postRequest(`${config.commonApiUrl}api/facility/v1/facility-tag`, data);
  },
  /**
   * Fetch all the facility tags function
   * @param query
   * @returns
   */
  fetchFacilityTagsList: () => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/facility-tag/list`);
  },
  /**
   * Fetch my facility tags function
   * @param query
   * @returns
   */
  fetchCurrentFacilityTagsList: () => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/facility-tag/my-facilities`);
  },
  /**
   * Fetch facility tags API
   * @param query
   */
  fetchFacilityTags: (query: QueryParameters = {}) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(`${config.commonApiUrl}api/facility/v1/facility-tag/`, {
      ...parameters,
    });
  },

  /**
   * Update the facility tag api call function
   * @param data
   * @returns
   */
  editFacilityTag: (id: string, data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(`${config.commonApiUrl}api/facility/v1/facility-tag/${id}`, {
      ...parameters,
    });
  },

  /**
   * Delete facility tag API
   * @param id
   * @returns
   */
  deleteFacilityTag: (id: string): Promise<any> => {
    return deleteRequest(`${config.commonApiUrl}api/facility/v1/facility-tag//${id}`);
  },

  /**
   * Fetch facility API
   * @returns 
   */
  fetchListFilters: () => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/facility-tag/list-filters`);
  },
};
